import React from 'react';
import { FaQuoteLeft } from 'react-icons/fa'

const testimonials = [
  {
    id: 1,
    name: 'Adana Okafor',
    company: 'Lagos Fintech Labs',
    testimonial: 'Working with this team has been an absolute pleasure. Their expertise and dedication have significantly improved our project outcomes.',
    image: 'https://images.unsplash.com/photo-1559172802-f5de3d1ed91d?q=80&w=387&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
  },
  {
    id: 2,
    name: 'Chinedu Adeyemi',
    company: 'Abuja Realty Partners',
    testimonial: "I'm impressed by their ability to deliver high-quality results consistently. They've become an invaluable partner for our business.",
    image: 'https://images.unsplash.com/photo-1531384441138-2736e62e0919?q=80&w=387&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
  },
  {
    id: 3,
    name: 'Ifeoma Nwosu',
    company: 'Kano Agro Ventures',
    testimonial: 'Their innovative approach and attention to detail have helped us stand out in a competitive market. Highly recommended!',
    image: 'https://images.unsplash.com/photo-1594750852491-e09aa1d75c78?q=80&w=387&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
  },
  {
    id: 4,
    name: 'Tunde Balogun',
    company: 'Port Harcourt Logistics',
    testimonial: 'As a startup, we needed a team that could adapt quickly and deliver results. They exceeded our expectations on every level.',
    image: 'https://images.unsplash.com/photo-1617244147299-5ef406921c35?q=80&w=387&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
  },
];

const ClientTestimonials = () => {
  return (
    <div className="container mx-auto px-6 py-16">
      <h2 className="text-4xl font-extrabold text-center mb-12 text-primary tracking-wide">
        What Our Clients Say
      </h2>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
        {testimonials.map((testimonial) => (
          <div
            key={testimonial.id}
            className="bg-gradient-to-r from-gray-100 to-gray-50 rounded-lg shadow-md shadow-slate-100 hover:shadow-lg hover:shadow-slate-200 transition-shadow duration-300 p-6 flex flex-col items-center text-center"
          >
            <img
              src={testimonial.image || '/placeholder.svg'}
              alt={testimonial.name || 'User'}
              className="w-24 h-24 rounded-full mb-4 object-cover border-4 border-gray-200"
            />
            <FaQuoteLeft className="text-4xl text-gray-400 mb-4" />
            <p className="text-gray-600 mb-4 italic leading-relaxed">
              "{testimonial.testimonial}"
            </p>
            <h3 className="text-xl font-semibold text-primary">{testimonial.name}</h3>
            <p className="text-secondary">{testimonial.company}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ClientTestimonials;
